import { render, staticRenderFns } from "./Related.vue?vue&type=template&id=2ae5cade&"
import script from "./Related.vue?vue&type=script&lang=js&"
export * from "./Related.vue?vue&type=script&lang=js&"
import style0 from "./Related.vue?vue&type=style&index=0&id=2ae5cade&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports